<!-- calendar heading -->
<div class="flex flex-middle flex-justify-between flex-middle bg-col-4 p-a-2 p-a-1-s">
    <!-- prev month -->
    <button class="icon-chevron-left inline-block"
            type="button"
            (click)="prevMonth()"
            [attr.aria-label]="'Previous month' | translate"></button>

    <!-- current month -->
    <div class="flex-grow center col-1"
         [sizeClass]="'S:p1, !S: p1'">{{monthDate | date : 'MMMM yyyy'}}</div>

    <!-- next month -->
    <button class="icon-chevron-right inline-block"
            type="button"
            (click)="nextMonth()"
            [attr.aria-label]="'Next month' | translate"></button>
</div>
<!-- calendar body -->
<div class="bg-col-w b-a b-col-4">
    <div class="_body col-1">
        <table>

            <!-- week days names -->
            <tr>
                @for (weekDay of weekDays; track $index) {
                <td [sizeClass]="'S:c1, !S: p2'">
                    <span class="_day">{{weekDay | date:'EEE'}}</span>
                </td>
                }
            </tr>

            <!-- weeks -->
            @for (week of weeks; track $index) {
            <tr>
                <!-- days -->
                @for (day of week; track $index) {
                <td [class._picked]="day?.isPicked">
                    @if (day) {
                    <span [ngClass]="client.isS ? 'c1' : 'p1'"
                          [style.font-weight]="isPicked(day) ? 600 : 400"
                          class="_day"
                          (click)="pick(day)"
                          [class.col-12]="isDisabled(day)"
                          [class.cursor-pointer]="!isDisabled(day)">{{day | date: 'd'}}
                    </span>
                    }
                </td>
                }
            </tr>
            }
        </table>
    </div>
</div>
